import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
    const [menuActive, setMenuActive] = useState(false);

    const openMenu = () => setMenuActive(true);
    const closeMenu = () => setMenuActive(false);

    return (
        <>
            <header>
                <div className="menuSec wow fadeInDown" data-wow-duration="2s">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-2 col-md-2 col-12">
                                <div className="header-logo">
                                    <Link to="/"><img src="images/logo.png" alt="img" /></Link>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 col-12 d-none d-md-block">
                                <div className="menusec-search-bar">
                                    <form>
                                        <input type="text" name="text" placeholder="search........." />
                                        <div className="menusec-search-bar-btn">
                                            <button type="submit">Search</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-4 col-12">
                                <div className="menu-right-btn">
                                    <div className="menusec-accounts-icon">
                                        <ul>
                                            <li>
                                                <Link to="/account" className="menusec-user">
                                                    <i className="fas fa-user" />
                                                    <p>Accounts</p>
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="/cart" className="menusec-shopping">
                                                    <i className="fas fa-shopping-bag" /> <span>3</span>
                                                </Link>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="menusec-button">
                                        <ul>
                                            <li>
                                                <button className="menusec-menu-btn" onClick={openMenu}>
                                                    <i className="fas fa-bars" />
                                                </button>
                                            </li>
                                            <li><Link to="/products" className="theme-btn-1">SHOP NOW</Link></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>

            <div className={`menu-overlay ${menuActive ? "active" : ""}`} id="menuOverlay"
                onClick={(e) => {
                    if (e.target.tagName === "A") closeMenu();
                }}>
                <span className="close-btn" onClick={closeMenu}>
                    ×
                </span>
                <ul className="menu-items">
                    <li><Link to="/">Home</Link></li>
                    <li><Link to="/about">About</Link></li>
                    <li><Link to="/products">Products</Link></li>
                    <li><Link to="/reviews">Reviews</Link></li>
                    <li><Link to="/contact">Contact</Link></li>
                </ul>
            </div>

        </>
    );
};

export default Header;
